<template>
  <Transition name="mdrawer">
    <div
      v-show="showDrawer"
      class="m-drawer bg-assist-white dark:bg-bgColor-global"
      :style="{
        'z-index': zIndex
      }"
    >
      <div class="h-full">
        <div ref="head" class="m-drawer-header">
          <span
            :style="{
              visibility: showTitle ? 'visible' : 'hidden'
            }"
            class="title"
            >{{ title }}
          </span>
          <span v-if="showClose" class="icon" @click="showDrawer = false">
            <SvgIcon class-name="icon" icon-class="close" />
          </span>
        </div>
        <div
          class="m-drawer-content"
          :style="{
            'max-height': contentH,
            overflow: 'auto'
          }"
        >
          <slot name="content"></slot>
        </div>
        <div
          v-if="showFooter"
          ref="foot"
          class="m-drawer-footer"
          :class="[isFooterBorder ? '' : 'noborder']"
          :style="{
            'max-width': footerWidth
          }"
        >
          <slot name="footer"></slot>
        </div>
      </div>
      <div ref="modal" class="v-modal" @click="onShow"></div>
    </div>
  </Transition>
</template>
<script>
export default {
  name: 'MDrawer',
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    isFooterBorder: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      open: false,
      isNeedBackLastRoute: false,
      contentHeight: '80vh',
      zIndex: 999,
      footerWidth: '100%'
    }
  },
  computed: {
    showDrawer: {
      get() {
        return this.show
      },
      set(v) {
        setTimeout(() => {
          this.initModal(v)
          this.$emit('close')
          this.$emit('update:show', v)
        }, 200)
      }
    },
    contentH() {
      return this.contentHeight
    }
  },
  watch: {
    showDrawer(n) {
      if (n) {
        this.footerWidth = window.innerWidth + 'px'
        window.zIndex += 1
        this.zIndex = window.zIndex
        setTimeout(() => {
          if (this.showFooter) {
            this.contentHeight = `calc(80vh - ${this.$refs.head.clientHeight}px - ${this.$refs.foot.clientHeight}px)`
          } else {
            this.contentHeight = `calc(80vh - ${this.$refs.head.clientHeight}px)`
          }
        }, 300)
      }
      this.initModal(n)
    }
  },
  methods: {
    onShow() {
      if (this.closeOnClickOverlay) {
        this.showDrawer = false
      }
    },
    createPreventForwardEvent() {
      history.pushState(null, null, location.href)
      this.isNeedBackLastRoute = true
      window.addEventListener('popstate', this.preventForwardHandler)
    },
    preventForwardHandler() {
      if (this.showDrawer) {
        this.isNeedBackLastRoute = true
        history.go(1)
      }
    },
    destroyPreventForwardEvent() {
      if (this.isNeedBackLastRoute) {
        history.go(-1)
        this.isNeedBackLastRoute = false
      }
      window.removeEventListener('popstate', this.preventForwardHandler)
    },
    initModal(n) {
      if (n) {
        document.body.appendChild(this.$el)
        document.body.appendChild(this.$refs.modal)
        document.body.style.overflow = 'hidden'
        this.$refs.modal.style.display = 'block'
        this.$refs.modal.style.zIndex = this.zIndex - 1
        this.createPreventForwardEvent()
      } else {
        this.destroyPreventForwardEvent()
        setTimeout(() => {
          document.body.style.overflow = 'auto'
          if (document.body.contains(this.$refs.modal)) {
            document.body.removeChild(this.$refs.modal)
          }
        }, 200)
      }
    }
  }
}
</script>
<style lang="scss">
.m-drawer {
  position: fixed;
  bottom: 0;
  z-index: 2000;
  width: 100%;
  max-height: 82vh;
  border-radius: theme('borderRadius.large') theme('borderRadius.large') 0 0;

  @include global.safeAreaBottom();

  .m-drawer-header {
    display: flex;
    justify-content: space-between;
    padding-top: 24px;
    padding-right: 24px;
    padding-left: 24px;

    .title {
      overflow: hidden;
      font-family: theme('fontFamily.pingFang');
      font-size: theme('fontSize.middlePlus');
      font-weight: 500;
      line-height: 22px;
      color: theme('colors.text.regular');
      text-overflow: ellipsis;
      word-break: keep-all;
    }

    .icon {
      width: 22px;
      height: 22px;
    }
  }

  .m-drawer-content {
    padding: 24px;
    overflow: auto;
  }

  .m-drawer-footer {
    padding: 18px 24px;
    background: theme('colors.bgColor.module');
    border-top: 1px solid theme('colors.divide');

    .footer,
    .dialog-footer {
      display: grid;
      // grid-template-columns: 1fr 1fr;
      gap: 12px;
      width: 100%;

      &:has(> div:nth-child(1)) {
        grid-template-columns: 1fr;
      }

      &:has(> div:nth-child(2)) {
        grid-template-columns: 1fr 1fr;
      }

      &:has(> div:nth-child(3)) {
        grid-template-columns: 1fr 1fr 1fr;
      }

      > div {
        margin-left: 0;

        .el-button {
          width: 100%;
          height: 40px;
        }
      }

      &.one {
        grid-template-columns: 1fr;
      }

      &.two {
        grid-template-columns: 1fr 1fr;
      }

      &.three {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }

  .noborder {
    border: none;
  }
}
</style>
